import React, { FC } from 'react'
import Script from 'next/script'
import { yotpoStarNoReviews } from '../utils/yotpoStarNoReviews'

export type YotpoScriptsProps = {
    id?: number | string
    enabled: boolean
    apiKey: string
}

/**
 * Embeds the Yotpo widget script into the dom
 * Need to change the approch after the upgrade
 */
export const YotpoScripts: FC<YotpoScriptsProps> = ({
    id = 0,
    enabled = false,
    apiKey
}) => {
    if (!enabled || !apiKey) return null

    return (
        <Script
            id={`yotpo-script-${id}`}
            src={`//staticw2.yotpo.com/${apiKey}/widget.js`}
            strategy="lazyOnload"
            onLoad={() => {
                yotpoStarNoReviews()
            }}
        />
    )
}
